import { StoreGateLogGetRequestCategoryOfPlanEnum } from "../api/main";
import { Plan } from "../store/slice/logSlice";

export const entrancePlanEnumConverter = (order: Plan):  StoreGateLogGetRequestCategoryOfPlanEnum => {
  switch (order) {
    case 'subscribe': return  StoreGateLogGetRequestCategoryOfPlanEnum.Subscribe;
    case 'temporaryUse': return  StoreGateLogGetRequestCategoryOfPlanEnum.TemporaryUse;
    default: return  StoreGateLogGetRequestCategoryOfPlanEnum.Subscribe;
  }
}